<template>
  <b-container>
    <b-card no-body border-variant="msstream">
      <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">Register</b-card-header>
      <b-card-body>
      <b-form>
        <b-form-group id="loginGroup1"
                      label="Email address:"
                      label-for="loginInput1">
          <b-form-input id="loginInput1"
                        type="email"
                        v-model="form.email"
                        required
                        placeholder="Enter email address">
          </b-form-input>
        </b-form-group>
        <b-form-group id="loginInputGroup3"
                      label="Username:"
                      label-for="loginInput3">
          <b-form-input id="loginInput3"
                        type="text"
                        v-model="form.name"
                        required
                        placeholder="Enter a username">
          </b-form-input>
        </b-form-group>
        <b-form-group id="loginInputGroup2"
                      label="Password:"
                      label-for="loginInput2">
          <b-form-input id="loginInput2"
                        type="password"
                        v-model="form.password"
                        required
                        placeholder="Password">
          </b-form-input>
        </b-form-group>
        <b-row>
          <div class="col-md-2"></div>
          <b-button class="col-md-3" @click="onSubmit()" variant="primary">Register</b-button>
          <div class="col-md-2"></div>
          <b-button class="col-md-3" @click="onReset()" variant="mswarning">Reset</b-button>
        </b-row>
      </b-form>
      </b-card-body>
    </b-card>
        <b-modal ref="myModalRef" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <ul>
      <li v-for="(error, index) in errors" v-bind:key="index">
          <p>{{error}}</p>
      </li>
      </ul>
      <b-btn class="mt-3" variant="labri3" block @click="hideModal">OK</b-btn>
    </b-modal>
  </b-container>
</template>

<script>
import UserService from '@/services/user.service'
import { EventBus } from '@/event-bus.js';
var userService = new UserService();
export default {
  name: "Register",
  data: function() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        clientName: "viewsurf"
      },
      errors: []
    };
  },
  methods: {
    onSubmit: function() {
      if (this.validateForm()) {
        userService.postUserUnsecure(this.form).then(() => {
          this.$auth.setUsernamePassword(this.form.email,this.form.password)
          .then((success) => {
            EventBus.$emit('AuthChanged');
            this.$router.push('/')
          }).catch(()=>{
            this.errors = [];
            this.errors.push('Error during log in after register');
            this.showModal();
          })
        }).catch(() => {
            this.errors = [];
            this.errors.push('Unable to save the user, an user with this email or username may already exist');
            this.showModal();
      });
      } else {
        this.showModal();
      }
    },
    onReset: function() {
      this.form = {
        email: "",
        username: "",
        password: ""
      }
    },
    validateForm: function() {
      var isValidated = true;
      this.errors = [];
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.form.email)) {
         isValidated = false;
         this.errors.push("Invalid email address");
      }
      return isValidated;
    },
    showModal () {
      this.$refs.myModalRef.show();
    },
    hideModal () {
      this.$refs.myModalRef.hide();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>